(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/setup-player.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/setup-player.js'); 'use strict';

const {
  registerHeaderComponents
} = svs.components.emp_video_player.helpers.setupHeader;
const {
  registerFooterComponents
} = svs.components.emp_video_player.helpers.setupFooter;
const setupPlayer = options => {
  if (svs.core.detect.formfactor.mobile() && svs.core.detect.os.iOS() && $('video')[0]) {
    $('video')[0].setAttribute('playsinline', '');
    svs.core.detect.orientation.on('change', function () {
      if (svs.core.detect.orientation.isLandscape()) {
        $('video')[0].removeAttribute('playsinline');
        player.requestFullscreen();
      } else {
        $('video')[0].setAttribute('playsinline', '');
        player.exitFullscreen();
      }
    });
  }
  const player = options.player;
  const ModalDialog = empPlayer.videojs.getComponent('ModalDialog');
  if (options && options.posterImg) {
    player.poster(options.posterImg);
  }
  const modal = new ModalDialog(player, {
    description: ' ',
    uncloseable: true,
    temporary: false
  });
  modal.addClass('streamplayer-overlay');
  modal.removeClass('vjs-hidden');
  player.addChild(modal, {}, 1);
  modal.close();
  const Button = empPlayer.videojs.getComponent('Button');
  const PrevButton = empPlayer.videojs.extend(Button, {
    constructor: function () {
      Button.apply(this, arguments);
      this.addClass('rewind-btn');
      this.addClass('icon');
      this.addClass('icon-rewind');
      this.controlText('Previous');
    },
    handleClick: function () {
      const now = player.currentTime();
      player.currentTime(now - 15);
    }
  });
  const ForwardButton = empPlayer.videojs.extend(Button, {
    constructor: function () {
      Button.apply(this, arguments);
      this.addClass('forward-btn');
      this.addClass('icon');
      this.addClass('icon-fast-forward');
      this.controlText('Forward');
    },
    handleClick: function () {
      const now = player.currentTime();
      player.currentTime(now + 15);
    }
  });
  const BigPausButton = empPlayer.videojs.extend(Button, {
    constructor: function () {
      Button.apply(this, arguments);
      this.addClass('big-pause-btn');
      this.addClass('vjs-icon-pause');
      this.controlText('Paus');
    },
    handleClick: function () {
      player.pause();
    }
  });
  registerFooterComponents();
  registerHeaderComponents();
  empPlayer.videojs.registerComponent('BigPausButton', BigPausButton);
  empPlayer.videojs.registerComponent('PrevButton', PrevButton);
  empPlayer.videojs.registerComponent('ForwardButton', ForwardButton);
  player.addChild('BigPausButton', {});
  if (player.duration() && player.duration() === 'Infiniyt') {
    player.removeChild('PrevButton');
  } else {
    player.addChild('PrevButton', {});
  }
  player.on('durationchange', function () {
    if (player.duration() === 'Infinity') {
      player.removeChild('PrevButton');
      player.removeChild('ForwardButton');
    } else {
      if (!player.getChild('PrevButton')) {
        player.addChild('PrevButton', {});
      }
      if (!player.getChild('ForwardButton')) {
        player.addChild('ForwardButton', {});
      }
    }
  });
  if (options && options.onVideoEndedHandler) {
    player.on('ended', function () {
      this.PosterImage.show();
      options.onVideoEndedHandler();
    });
  }
};
svs.components.emp_video_player.helpers.setupPlayer = {
  setupPlayer: setupPlayer
};
 })(window);